export { default as PauseAltOutlineIcon } from './PauseAltOutlineIcon';
